import getOperation from "../../helpers/getOperation"

import IndexActivitiesOutputShape from "./IndexActivitiesOutputShape"
import IndexInvestorActivitiesOutputShape from "./IndexInvestorActivitiesOutputShape"
import ReadActivityOutputShape from "./ReadActivityOutputShape"

export {
  IndexActivitiesOutputShape,
  IndexInvestorActivitiesOutputShape,
  ReadActivityOutputShape
}

export const indexActivitiesOperation = getOperation("activities/IndexActivities")
export const indexInvestorActivitiesOperation = getOperation("activities/IndexInvestorActivities")
export const readActivityOperation = getOperation("activities/ReadActivity")
